import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { Link } from 'react-router-dom';

import i18n from 'app/common/i18n';
import Dialog from 'app/common/dialog';

import DrawerBranding from './drawer-branding';

import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Icon from '@mui/material/Icon';
import IconButton from '@mui/material/IconButton';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import { styled } from '@mui/material/styles';

import styles from './nav-styles';

const StyledDrawer = styled(Drawer)(({ theme }) => {
  const classes = styles(theme);

  return {
    '& .app-drawer-paper': classes.drawerPaper
  };
});

const StyledAppBar = styled(AppBar)(({ theme }) => {
  const classes = styles(theme);

  return classes.appBar;
});

class AppDrawer extends Component {
  static propTypes = {
    desktop: PropTypes.bool.isRequired,
    logout: PropTypes.func.isRequired,
    show: PropTypes.bool.isRequired,
    toggle: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      dialog: null
    };
  }

  toggle = (state) => {
    this.props.toggle(state);
  };

  close = () => {
    this.props.toggle(false);
  };

  handleLogout = (ev) => {
    const dialog = {
      open: true,
      title: this.props.i18n('Sign Out'),
      submitLabel: this.props.i18n('Sign Out'),
      children: this.props.i18n('Are you sure, you want to sign out?'),
      onClose: () => {
        this.setState({ dialog: null });
      },
      onSubmit: () => {
        this.setState({ dialog: null });
        if (!this.props.desktop) {
          this.close(ev);
        }
        this.props.logout();
      }
    };

    this.setState({ dialog });
  };

  render() {
    const { dialog } = this.state;
    const { desktop, show, user } = this.props;

    const onClick = !desktop ? this.close : undefined;

    const items = [];

    const isAdmin = user && user.get('role') === 'admin';

    if (isAdmin) {
      items.push(
        <MenuItem
          key="dwellings-list"
          onClick={onClick}
          component={Link}
          to="/dwellings/"
        >
          <ListItemIcon>
            <Icon>home</Icon>
          </ListItemIcon>
          <ListItemText primary={this.props.i18n('Dwellings')} />
        </MenuItem>
      );
      items.push(
        <MenuItem
          key="dwellings-create"
          onClick={onClick}
          component={Link}
          to="/dwellings/create"
          reloadDocument
        >
          <ListItemIcon>
            <Icon>add</Icon>
          </ListItemIcon>
          <ListItemText primary={this.props.i18n('Create dwelling')} />
        </MenuItem>
      );
      items.push(
        <MenuItem
          key="message-list"
          onClick={onClick}
          component={Link}
          to="/messages/"
        >
          <ListItemIcon>
            <Icon>mail</Icon>
          </ListItemIcon>
          <ListItemText primary={this.props.i18n('Messages')} />
        </MenuItem>
      );
      items.push(
        <MenuItem
          key="boligsoeger-list"
          onClick={onClick}
          component={Link}
          to="/boligsoegerlisten/"
        >
          <ListItemIcon>
            <Icon>people</Icon>
          </ListItemIcon>
          <ListItemText primary={this.props.i18n('Boligsøgerlisten')} />
        </MenuItem>
      );
      items.push(
        <MenuItem
          key="users-list"
          onClick={onClick}
          component={Link}
          to="/users/"
        >
          <ListItemIcon>
            <Icon>people</Icon>
          </ListItemIcon>
          <ListItemText primary={this.props.i18n('Users')} />
        </MenuItem>
      );
      items.push(
        <MenuItem
          key="activity-list"
          onClick={onClick}
          component={Link}
          to="/activity/"
        >
          <ListItemIcon>
            <Icon>list</Icon>
          </ListItemIcon>
          <ListItemText primary={this.props.i18n('Activity')} />
        </MenuItem>
      );
      items.push(
        <MenuItem
          key="feedback-list"
          onClick={onClick}
          component={Link}
          to="/feedback/"
        >
          <ListItemIcon>
            <Icon>feedback</Icon>
          </ListItemIcon>
          <ListItemText primary={this.props.i18n('Feedback')} />
        </MenuItem>
      );
      items.push(
        <MenuItem
          key="statistics"
          onClick={onClick}
          component={Link}
          to="/statistics"
        >
          <ListItemIcon>
            <Icon>list</Icon>
          </ListItemIcon>
          <ListItemText primary={this.props.i18n('Statistics')} />
        </MenuItem>
      );
      items.push(
        <MenuItem
          key="discounts-list"
          onClick={onClick}
          component={Link}
          to="/discounts/"
        >
          <ListItemIcon>
            <Icon>list</Icon>
          </ListItemIcon>
          <ListItemText primary={this.props.i18n('Discounts')} />
        </MenuItem>
      );
      items.push(
        <MenuItem
          key="payments-list"
          onClick={onClick}
          component={Link}
          to="/payments/"
        >
          <ListItemIcon>
            <Icon>payments</Icon>
          </ListItemIcon>
          <ListItemText primary={this.props.i18n('Payments')} />
        </MenuItem>
      );
    } else if (user) {
      items.push(
        <MenuItem
          key="dwellings-list"
          onClick={onClick}
          component={Link}
          to="/dwellings/"
        >
          <ListItemIcon>
            <Icon>list</Icon>
          </ListItemIcon>
          <ListItemText primary={this.props.i18n('My Dwellings')} />
        </MenuItem>
      );
      items.push(
        <MenuItem
          key="dwellings-create"
          onClick={onClick}
          component={Link}
          to="/dwellings/create"
          reloadDocument
        >
          <ListItemIcon>
            <Icon>add</Icon>
          </ListItemIcon>
          <ListItemText primary={this.props.i18n('Create dwelling')} />
        </MenuItem>
      );
      items.push(
        <MenuItem
          key="message-list"
          onClick={onClick}
          component={Link}
          to="/messages/"
        >
          <ListItemIcon>
            <Icon>mail</Icon>
          </ListItemIcon>
          <ListItemText primary={this.props.i18n('Messages')} />
        </MenuItem>
      );
      items.push(
        <MenuItem
          key="boligsoeger-list"
          onClick={onClick}
          component={Link}
          to="/boligsoegerlisten/"
        >
          <ListItemIcon>
            <Icon>people</Icon>
          </ListItemIcon>
          <ListItemText primary={this.props.i18n('Boligsøgerlisten')} />
        </MenuItem>
      );
    }

    items.push(<Divider key="account-divider" />);

    if (user) {
      if (!isAdmin) {
        items.push(
          <MenuItem
            key="account-settings"
            onClick={onClick}
            component={Link}
            className="profile-link"
            to="/profile"
          >
            <ListItemIcon>
              <Icon>settings</Icon>
            </ListItemIcon>
            <ListItemText primary={this.props.i18n('My Account')} />
          </MenuItem>
        );
      }

      items.push(
        <MenuItem
          key="account-sign-out"
          onClick={this.handleLogout}
          className="logout"
        >
          <ListItemIcon>
            <Icon>lock</Icon>
          </ListItemIcon>
          <ListItemText primary={this.props.i18n('Sign Out')} />
        </MenuItem>
      );
    } else {
      items.push(
        <MenuItem
          key="account-sign-up"
          onClick={onClick}
          component={Link}
          to="/signup"
        >
          <ListItemIcon>
            <Icon>person_add</Icon>
          </ListItemIcon>
          <ListItemText primary={this.props.i18n('New landlord')} />
        </MenuItem>
      );
      items.push(
        <MenuItem
          key="account-sign-in"
          onClick={onClick}
          component={Link}
          to="/"
        >
          <ListItemIcon>
            <Icon>lock_open</Icon>
          </ListItemIcon>
          <ListItemText primary={this.props.i18n('Sign In')} />
        </MenuItem>
      );
    }

    return (
      <StyledDrawer
        PaperProps={{
          'data-cy': 'menubar',
          className: 'app-drawer-paper'
        }}
        variant={desktop ? 'permanent' : 'temporary'}
        anchor="left"
        open={show}
        onClose={this.toggle}
      >
        {dialog ? <Dialog {...dialog} /> : null}
        <StyledAppBar position="static">
          <Toolbar>
            {!desktop ? (
              <IconButton
                color="inherit"
                aria-label="Menu"
                onClick={this.close}
              >
                <Icon color="inherit">close</Icon>
              </IconButton>
            ) : null}
          </Toolbar>
        </StyledAppBar>
        {items}

        <DrawerBranding />
      </StyledDrawer>
    );
  }
}

export default i18n(AppDrawer);
